import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"
import { twMerge } from "tailwind-merge"

const buttonVariants = cva(
	"empreender-press active:scale-[0.97] select-none cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg !text-sm font-medium ring-offset-background focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&>svg]:size-4",
	{
		variants: {
			variant: {
				default: "bg-gray-900 text-white hover:opacity-90",
				secondary:
					"bg-gray-50 text-neutral-950 hover:opacity-90",
				destructive:
					"bg-[#E01E5A] text-white hover:opacity-90",
				success:
					"bg-[#2EB67D] text-white hover:opacity-90",
				outline:
					"border bg-white border-neutral-200 text-neutral-950 hover:bg-gray-100",
				ghost: "text-neutral-950 hover:bg-gray-100",
				link: "text-neutral-950 hover:underline underline-offset-[4px]",
				navigable: 'text-neutral-950 hover:bg-gray-100 text-neutral-950 font-normal justify-between items-center w-full'
			},
			size: {
				default: "px-4 py-2",
				icon: "size-9",
				navigable: 'p-2'
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	}
)

function Button({
	className,
	variant,
	size,
	asChild = false,
	...props
}: React.ComponentProps<"button"> &
	VariantProps<typeof buttonVariants> & {
		asChild?: boolean
	}) {
	const Comp = asChild ? Slot : "button"

	return (
		<Comp
			data-slot="button"
			className={twMerge(buttonVariants({ variant, size, className }))}
			{...props}
		/>
	)
}

export { Button, buttonVariants }
